import { useEffect, useState } from "react";
import { getBlogDetail, getBlogs } from "../services/api/api";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
const HowAIIsReshapingTheFutureIn = () => {
  const settings = {
    slidesToShow: 3.5,
    slidesToScroll: 1,
    draggable: true,
    arrows: false,
    className: "blog_list",
    focusOnSelect: true,
    adaptiveHeight: false,
    prevArrow: (
      <div className="slickbtn slick-prev">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="25.5"
            cy="25.5"
            r="25.5"
            transform="rotate(180 25.5 25.5)"
            fill="url(#paint0_linear_17_4)"
          ></circle>
          <path
            d="M21.414 26L31 26L31 24L21.414 24L25.707 19.707L24.293 18.293L17.586 25L24.293 31.707L25.707 30.293L21.414 26Z"
            fill="white"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_17_4"
              x1="-0.721698"
              y1="21.675"
              x2="51.0345"
              y2="22.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09C2C1"></stop>
              <stop offset="1" stop-color="#1D85D8"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    ),
    nextArrow: (
      <div className="slickbtn slick-next">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="25.5"
            cy="25.5"
            r="25.5"
            fill="url(#paint0_linear_17_8)"
          ></circle>
          <path
            d="M29.586 25L20 25L20 27L29.586 27L25.293 31.293L26.707 32.707L33.414 26L26.707 19.293L25.293 20.707L29.586 25Z"
            fill="white"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_17_8"
              x1="-0.721698"
              y1="21.675"
              x2="51.0345"
              y2="22.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09C2C1"></stop>
              <stop offset="1" stop-color="#1D85D8"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  };

  const [blog, setBlog] = useState([]);
  let { blogId } = useParams();
  useEffect(() => {
    getBlogDetail(blogId).then((res) => {
      setBlog(res.data.result);
    });
  }, []);
  console.log(blog);
  return (
    <>
      <div
        className="blog_banner blog-dtl"
        style={{ backgroundImage: "url(./assets/images/new/blog-dtl.png)" }}
      >
        <div className="wrapper">
          <div className="blog-dtl-block">
            <a href="/blogs">
              <img src="/assets/images/new/arrow-blog.svg" alt="arrow" />
            </a>
            {/* this is banner is dynamic */}
            <img src="/assets/images/blogs/blogdtl18.png" alt="blog" />
          </div>
        </div>
      </div>
      <div className="block-dtl">
        <div className="wrapper">
          <div className="social">
            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Facebook.svg"
                alt="facebook"
              />
            </a>
            <a href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Linkedin.svg"
                alt="facebook"
              />
            </a>
            <a href="https://pinterest.com/pin/create/button/?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img src="/assets/images/site/social/Social.svg" alt="facebook" />
            </a>
            <a href="https://x.com/intent/tweet?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/twitter.png"
                alt="facebook"
              />
            </a>
            <a href="https://www.instagram.com/?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Instagram.svg"
                alt="facebook"
              />
            </a>
          </div>
          <div className="title">
            <div className="title-head">
              <a
                data-aos="zoom-out-up"
                href="javascript:void(0)"
                className="button-container-1 aos-init aos-animate"
              >
                <span className="mas">
                AI Trends and Innovations
                  {/* this is tag name (dynamic) */}
                </span>
                <span className="mask_btn">
                AI Trends and Innovations
                  {/* this is tag name (dynamic) */}
                </span>
              </a>

              <span>June 27, 2025</span>
            </div>
            {/* all this content is dynamic  */}
            <div
            // dangerouslySetInnerHTML={{ __html: blog.page_content }}
            >
              <h2>
              How AI is Reshaping the Future in 2025
              </h2>
              <p>
             From classrooms to clinics to checkouts — AI is no longer just an idea, it’s the engine driving transformation across industries.
              </p>
              
              <p>Artificial Intelligence (AI) is not the future anymore — it’s the present, evolving rapidly and redefining how we live, learn, shop, and stay healthy. In 2025, AI is no longer limited to innovation labs or Silicon Valley giants. It’s quietly but powerfully transforming everyday experiences. At CodeFlix Web LLP, we’re proud to be a part of this transformation, helping businesses harness AI to unlock smarter solutions and better outcomes.Let’s take a look at how AI is reshaping key industries:</p>
              
              <h3>Education: Learning Gets Smarter and More Personal</h3>
              <p>
              Traditional classrooms are becoming intelligent ecosystems where AI adapts to each student’s pace and learning style. Tools powered by machine learning and natural language processing provide:
              </p>
                <ul>
                    <li>Personalized learning paths that cater to individual strengths and weaknesses.</li>
                    <li>Intelligent tutoring systems that give real-time feedback and guidance.</li>
                    <li>AI-generated content that supports teachers in lesson planning and student assessments.</li>
                </ul>
                <p>In 2025, students are no longer bound by one-size-fits-all education — they’re empowered by AI to learn in ways that work best for them.</p>
              <h3>Healthcare: From Reaction to Proactive Care</h3>
              <p>The healthcare sector has embraced AI not only for clinical efficiency but also for life-saving innovation. Today’s AI-driven tools are enabling:</p>
                <ul>
                    <li>Faster, more accurate diagnoses using predictive models and image analysis.</li>
                    <li>24/7 virtual healthcare assistants that triage patient symptoms and provide advice.</li>
                    <li>AI in genomics and drug discovery, reducing the time needed to develop personalized medicine.</li>
                </ul>
              <p>By automating routine tasks and accelerating data analysis, AI is helping doctors focus more on patient care than paperwork — and patients get faster, better support.</p>
              
              <h3>E-Commerce: Predictive Shopping Meets the Human Touch</h3>
              <p>
             In 2025, the online shopping experience is practically clairvoyant. AI knows what customers want before they even do. Here's how:
              </p>
               <ul>
                    <li>Predictive analytics that recommend products based on browsing behavior, purchase history, and even mood.</li>
                    <li>AI-powered chatbots and virtual stylists that assist customers like human agents.</li>
                    <li>Hyper-personalized marketing based on real-time customer data and intent signals.</li>
                </ul>
                <p>With AI, e-commerce is no longer transactional — it’s relational. Customers feel understood, not targeted.</p>
              
              <h3>Building the Future at CodeFlix Web LLP</h3>
              <p>
              At CodeFlix Web, we don’t just talk about the future — we’re helping to build it. From AI-integrated web portals to smart design tools and custom automation solutions, we’re empowering businesses to:
              </p>
              <ul>
<li>Integrate AI into user experiences across mobile and web platforms.</li>
<li>Develop intelligent backend systems that improve operations and customer engagement.</li>
<li>Leverage generative AI tools for creative, content-driven innovation.</li>
</ul>

              <p>
              Whether it’s a smarter e-commerce platform or a healthcare dashboard powered by machine learning, our team is behind the scenes engineering the change.
              </p>
             
            </div>
          </div>
        </div>
      </div>
      <div className="topics-sec">
        <div className="wrapper">
          <div className="topics-head">
            <h3>related topics</h3>
            <a
              data-aos="zoom-out-up"
              href="/blogs"
              className="button-container-1 aos-init aos-animate"
            >
              <span className="mas">View More</span>
              <span className="mask_btn">View More</span>
            </a>
          </div>
          <div className="topics-block">
            <Slider {...settings}>
              {/* href id is dynamic like blog/item.id */}
              <a href={`/best-web-development-company`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog1.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span> Web Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Best Web Development Company: Transforming Your Digital
                        Presence Globally
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/custom-mobile-app-development-services`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog16.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span>App Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Elevate Your Business with Custom Mobile App Development
                        Services
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/leading-php-company`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog15.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span> Web Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Leading PHP Development Company in India: Unlocking Your
                        Digital Potential
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/best-UI-UX-design`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="/assets/images/blogs/blog9.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span>ui & ux</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        We Provide the Best UI/UX Design Solutions for
                        Exceptional User Experiences{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowAIIsReshapingTheFutureIn;
